import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
export function EraVisualEffects() {
  const {
    currentEra
  } = useTheme();
  return <>
      {currentEra === '60s' && <div className="film-grain" data-id="element-50"></div>}
      {currentEra === '70s' && <div className="retro-texture" data-id="element-51"></div>}
      {currentEra === '80s' && <div className="memphis-pattern" data-id="element-52"></div>}
      {currentEra === '90s' && <div className="photocopy-texture" data-id="element-53"></div>}
      {currentEra === '2000s' && <div className="digital-artifacts" data-id="element-54"></div>}
    </>;
}